
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"19","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10012_35451)"}},[_c('path',{attrs:{"d":"M8.034 1.85L5.837 6.303.922 7.02C.04 7.148-.313 8.235.326 8.858l3.557 3.465-.841 4.895c-.152.885.78 1.548 1.56 1.134L9 16.041l4.397 2.311c.78.41 1.713-.249 1.562-1.134l-.842-4.895 3.557-3.465c.639-.623.286-1.71-.596-1.837l-4.915-.717-2.197-4.455c-.394-.794-1.535-.804-1.932 0z","fill":"#910000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10012_35451"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    